<template>
  <div class="QuestionsAndAnswers answerarea-item fontsize-16" :id="questionitem.innerid">
    <div class="topic-types">
        <p class="name" v-if="!isMaterialsItem"><span>{{questionitem.questionindex}}.</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
        <p class="name" v-else><span>{{questioninfo.questionindex}}.{{questionitem.questionindex}}</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
        <p class="title" v-html="questionitem.subject"></p>
        <div class="option-list">
            <!-- <div class="option-item" v-for="(options, index) in questionitem.finalanswerblank.answerblank" :key="index"> -->
            <div class="option-item" v-for="(options, index) in questionitem.uselanswer" :key="index">
              <i class="el-icon-view" style="visibility:hidden"></i>
              <!-- end 占位用图标 -->
                <div class="input">
                  <p class="number">{{index+1}}</p>
                  <el-input v-model="questionitem.uselanswer[index].value" :disabled="examstatus == 1"></el-input>
                </div>
            </div>
            <!-- <div class="option-item">
                <i class="el-icon-check"></i>
                <div class="input">
                  <p class="number">1</p>
                  <el-input></el-input>
                </div>
            </div> -->
        </div>
      </div>
      <div class="topic-types answer" v-if="examstatus == 1 || isshow == 1">
        <p>
          <span>本题得分：</span>
          <span class="fraction">{{questionitem.userscore}}分</span>
        </p>
        <p>
          <span>正确答案：</span>
          <span>{{questionitem.finalanswerblank.answerblank | splitList}}</span>
        </p>
        <p>
          <span>答案解析：</span>
          <span v-html="questionitem.quesanalysis"></span>
        </p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionsAndAnswers',
  props: ['questionitem', 'examstatus', 'isshow', 'isMaterialsItem', 'questioninfo'], // 试题列表 试卷提交状态 是否显示正确答案
  data () {
    return {
      questionsAndAnswersArray: {
        // 填空题对象
        value: ''
      },
      questionsAndAnswersList: []
    }
  },
  mounted () {
    this.$nextTick(() => {
        // 未提交答案情况下 初始化填空题答案数组 
        // 如果存在情况下则渲染出所答答案
        // 循环绑定填空题
        this.init()
    })
  },
  updated() {
    // this.init()
  },
  methods: {
    init() {  // 初始化填空
      if (this.questionitem.uselanswer.length > 0 || this.examstatus == 1) {

          if (typeof this.questionitem.uselanswer !== 'object') {
            let uselanswerSplit = this.questionitem.uselanswer.split('|')
            
            this.questionitem.uselanswer = []

            for (let i = 0; i < uselanswerSplit.length; i++) {
              this.questionitem.uselanswer.push({value: uselanswerSplit[i]})
            }
          }

        } else {
          this.questionitem.uselanswer = []
          for(let i = 0; i < this.questionitem.finalanswerblank.answerblank.length; i++) {
            this.questionitem.uselanswer.push(JSON.parse(JSON.stringify(this.questionsAndAnswersArray)))
          }
        }
    }
  },
  filters: {
    splitList(list) {
      let txt = ""
      for (let i = 0; i < list.length; i++) {
        txt += list[i] + ', '
      }
      txt = txt.substr(0, txt.length - 2)
      return txt
        // console.log(list)
    }
  },
  watch: {
    questionitemData() {
      this.init()
    }
  },
  computed: {
    questionitemData() {
      return this.questionitem
    }
  },
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.QuestionsAndAnswers {
  .option-item {
    overflow: hidden;
    .input {
      float: left;
      position: relative;
      width: calc(100% - 80px);
      .number {
        position: absolute;
        z-index: 2;
        left: 1px;
        top: 1px;
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background: #E6F1FC;
        border-radius:4px 0px 0px 4px;
      }
      .el-input {
        height: 32px;
        input {
          height: 100%;
          padding-left: 40px;
        }
      }
    }
  }
}
</style>